<lib-icon
  class="icon-in-active"
  [name]="iconInActive"
  [@toggleIconAnim]="state() ? 'hidden' : 'visible'"
></lib-icon>

<lib-icon
  class="icon-active"
  [name]="iconActive"
  [@toggleIconAnim]="state() ? 'visible' : 'hidden'"
></lib-icon>
